import { Dispatch } from 'redux';
import { TGetRootState, TDispatchResult } from 'types/shared';

import {
  saveUserSettings,
  IUserSettingsState,
  IUserSettingsAction,
} from '../userSettings';
import { TItemCustomViewExtended } from 'components/CustomizeView/CustomizeView';

export const SET_CUSTOMIZE_VIEW = 'opus/user/customizeView/SET_CUSTOMIZE_VIEW';

export default function reducer(
  state: IUserSettingsState,
  action: IUserSettingsAction
): IUserSettingsState {
  switch (action.type) {
    case SET_CUSTOMIZE_VIEW: {
      return {
        ...state,
        ...action.payload,
      };
    }
    default:
      return state;
  }
}

export const setCustomizeView = (
  viewName: string,
  items: TItemCustomViewExtended[]
): TDispatchResult<any> => {
  return function (dispatch: Dispatch, getState: TGetRootState): any {
    const originalState = getState().userSettings.data.customizeViews;

    dispatch({
      type: SET_CUSTOMIZE_VIEW,
      payload: {
        ...originalState,
        [viewName]: items,
      },
    });

    // If getState().userSettings.success.all is false, this means we encountered an error while loading the
    // userSettings endpoint. It's safest not to overwrite this with the current Redux store anymore.
    if (getState().userSettings.success.all) {
      return dispatch(saveUserSettings('customizeViews') as any);
    }
    // eslint-disable-next-line no-console
    console.warn(
      'We are not saving your new customizeViews to the KV store because we could not retrieve them and do not want to run the risk of corrupting data.'
    );
  };
};
